import { render, staticRenderFns } from "./smartOrg.vue?vue&type=template&id=47cba54a&scoped=true"
import script from "./smartOrg.vue?vue&type=script&lang=ts"
export * from "./smartOrg.vue?vue&type=script&lang=ts"
import style0 from "./smartOrg.vue?vue&type=style&index=0&id=47cba54a&prod&lang=less"
import style1 from "./smartOrg.vue?vue&type=style&index=1&id=47cba54a&prod&lang=less&scoped=true"
import style2 from "./smartOrg.vue?vue&type=style&index=2&id=47cba54a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cba54a",
  null
  
)

export default component.exports